/*
 *
 * Date: 2025
 * Description: Fit modal context , for viewing parts fitements vehicules
 * Author: Philippe Leroux @SKITSC
 *
 */


//Components
import { createContext , useState , useContext, useEffect  } from "react";

//Interfaces
import { i_filter, i_fit_modal_props, i_sub_main_props } from "../interfaces/utility.interface";
import { i_user } from "../interfaces/user.interface";

//Components
import FitModal from "../components/modal/fit.modal";
import { i_car_fit, i_makes } from "../interfaces/items.interface";

//Utility functions && constants
import { handleFetch } from "../api/fetch";
import { default_search } from "../utils/constant";


const FitModalContext = createContext<{ showFitModal: (a : i_car_fit[]) => void , showFilteredModal: ( a : i_car_fit[] , b : i_filter) => void, closeModal : () => void }>({ showFitModal: () => {}, showFilteredModal: () => {}, closeModal : () => {} });

export const FitModalProvider = (props : i_sub_main_props) => {
    const [ modal , setModal ] = useState<i_fit_modal_props | null>(null);
    const [ makes , setMakes ] = useState<i_makes[]>([]);
    const [ pathing ] = useState<string>(props.uploadPath + props.path + '/uploads/parts/')
    useEffect(() => {
        const getMakes = async() => {
            const res = await handleFetch('/makes' , 'GET' , true , null)
            if(res.type === 'Success'){
                setMakes(res.data)
            }
        }
        getMakes()
    },[])
    const showFitModal = (item : i_car_fit[] ) => {
        const viewModalProps : i_fit_modal_props = {
            fit : item,
            clear : () => setModal(null),
            filter : default_search,
            makes : makes
        }
        setModal(viewModalProps);
    };
    const showFilteredModal = (item : i_car_fit[] , filter : i_filter ) => {
         const viewModalProps : i_fit_modal_props = {
            fit : item,
            clear : () => setModal(null),
            filter : filter,
            makes : makes
        }
        setModal(viewModalProps);
    }

    const closeModal = () => {
            setModal(null)
    };

  return (
    <FitModalContext.Provider value={{ showFitModal , showFilteredModal,  closeModal }}>
        {modal && <FitModal {...modal} />}
        {props.children}
    </FitModalContext.Provider>
  );
};

export const useFitModal = () => useContext(FitModalContext);